export default {
  notifications(state) {
    return state.notifications
  },
  unreadCount(state) {
    return state.unreadCount
  },
}
